// Ensure we have a global array to store Splide instances
window.productSplides = window.productSplides || [];

// Function to initialize Product Card Sliders
function initializeProductCardSliders() {
  const productSliders = document.querySelectorAll('.splide[id^="splide-product-"]');

  productSliders.forEach((slider) => {
    if (slider.classList.contains('splide-initialized')) return;
    slider.classList.add('splide-initialized');

    const inCollectionPage = slider.closest('.collection-page') !== null;
    // Inside the featured-collection slider: no drag or dots on mobile
    const inCollectionSlider = slider.closest('.collection-slider') !== null;

    const isMobile = window.innerWidth < 768;
    const imageCount = parseInt(slider.dataset.imageCount || '1', 10);
    const hasMultiple = imageCount > 1;
    const fadeOnHover = !isMobile && hasMultiple;

    const config = {
      type: fadeOnHover ? 'fade' : 'loop',
      rewind: fadeOnHover,
      perPage: 1,
      drag: isMobile ? (inCollectionSlider ? false : (hasMultiple ? true : false)) : false,
      speed: isMobile ? 350 : 450,
      flickPower: 100,
      dragMinThreshold: { mouse: 4, touch: 20 },
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      arrows: isMobile ? false : hasMultiple,
      pagination: inCollectionSlider && isMobile ? false : hasMultiple,
    };

    try {
      const splideInstance = new Splide(slider, config).mount();

      if (fadeOnHover) {
        const card = slider.closest('.product-card');
        const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (card && canHover) {
          card.addEventListener('mouseenter', () => {
            if (window.innerWidth < 768) return;
            splideInstance.go(1);
          });
          card.addEventListener('mouseleave', () => {
            if (window.innerWidth < 768) return;
            splideInstance.go(0);
          });
        }
      }

      // Update active dot at the START of the move, not after transition ends
      splideInstance.on('move', (newIndex) => {
        const pages = slider.querySelectorAll('.splide__pagination__page');
        if (!pages.length) return;
        const realIndex = newIndex % pages.length;
        pages.forEach((page, i) => {
          page.classList.toggle('is-active', i === realIndex);
        });
      });

      window.productSplides.push(splideInstance);
    } catch (error) {
      console.error('Error initializing Product Card Splide slider:', error, slider);
    }
  });
}

// Ensure Splide.js is loaded before initializing
document.addEventListener('DOMContentLoaded', () => {
  window.MySplide.loadSplide(() => {
    initializeProductCardSliders();
  });
});

// Reinitialize sliders when Shopify sections are loaded dynamically
document.addEventListener('shopify:section:load', () => {
  initializeProductCardSliders();
});